import { Orb } from "orb-ui";

const ORB_STATES = new Set([
  "idle",
  "connecting",
  "listening",
  "thinking",
  "speaking",
  "error",
]);

const toOrbState = (state) => (ORB_STATES.has(state) ? state : "idle");

const AssistantOrbVisual = ({
  size,
  state = "idle",
  volume = 0,
  ariaLabel = "Assistant orb",
}) => (
  <Orb
    theme="cloud"
    size={size}
    state={toOrbState(state)}
    volume={volume}
    interactive={false}
    aria-label={ariaLabel}
  />
);

export default AssistantOrbVisual;
